package io.horion.cv.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.silk.style.toModifier
import io.horion.cv.styles.FormCardStyle
import io.horion.cv.utils.Colors
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px

@Composable
fun FormCard(
    modifier: Modifier = Modifier,
    content: @Composable () -> Unit
) {
    Column(
        modifier = FormCardStyle.toModifier()
            .border(1.px, LineStyle.Solid, Colors.Placeholder)
            .then(modifier)
    ) {
        content()
    }
}